import React from 'react'
import foodData from './FoodData'
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const LowPrice = () => {
    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="heading-menu">
                        <h2 className="title-menu pt-5 pb-5">
                            {" "}
                            Delivery Restaurant in Ahmedabad
                        </h2>
                    </div>
                    {
                        foodData.filter(food => food.price <= 350).
                            map((recipe, index) => (
                                <div className="container col-4 box p-0" key={index}>
                                    <img src={recipe.img} alt="" />
                                    <div className="dish-name mt-4 d-flex align-items-center justify-content-between">
                                        <h4 className="name-0f-food d-inline">
                                            {recipe.title}
                                        </h4>
                                        <p className="rating text-center d-inline">
                                            {recipe.rating}<FontAwesomeIcon className="icon-star" icon={faStar} />
                                        </p>
                                    </div>
                                    <div className="type-of-food w-auto mx-3 mt-2 d-flex align-items-center justify-content-between">
                                        <p className="d-inline">
                                            {recipe.maintitle}
                                        </p>
                                        <p className="d-inline">
                                            ₹ {recipe.price} for 1
                                        </p>
                                    </div>
                                    <p className="delivery-time">55min</p>
                                </div>
                            ))}
                </div>
            </div>
        </>
    )
}

export default LowPrice